import { html } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import { navigate } from '../router';
import { stytch } from '../auth/session.ts';
import { LitPage } from '../components/lit-page.ts';

import '../components/luna-auth-card/luna-auth-card';
import '../components/luna-button/luna-button';

@customElement('app-forgot-password')
export class AppForgotPassword extends LitPage {
  @state() private email = '';
  @state() private busy = false;
  @state() private errorMessage = '';
  @state() private noticeMessage = '';

  private async onSubmit(e: Event) {
    e.preventDefault();
    if (this.busy) return;
    this.busy = true;
    this.errorMessage = '';
    this.noticeMessage = '';
    try {
      await stytch.passwords.resetByEmailStart({
        email: this.email,
        reset_password_redirect_url: `${window.location.origin}/auth/reset-password`,
      });
      this.noticeMessage = `We've emailed a password reset link to ${this.email}.`;
    } catch (err) {
      const errorType = (err as { error_type?: string })?.error_type;
      this.errorMessage = errorType === 'email_not_found'
        ? 'That email address isn\'t registered. Please check it and try again.'
        : 'We couldn\'t send the reset email. Please try again.';
    } finally {
      this.busy = false;
    }
  }

  content() {
    return html`
      <luna-auth-card>
        <h1 class="mbw-type-title-section">Reset your password</h1>
        <p>Enter your email address and we'll send you a link to choose a new password.</p>

        <div class="auth-error" role="alert" ?hidden=${!this.errorMessage}>
          ${this.errorMessage}
        </div>
        <div class="auth-notice" role="status" ?hidden=${!this.noticeMessage}>
          ${this.noticeMessage}
        </div>

        <form @submit=${this.onSubmit}>
          <div>
            <label for="forgot-email">Email address</label>
            <input
              id="forgot-email"
              type="email"
              autocomplete="email"
              required
              .value=${this.email}
              @input=${(e: Event) => { this.email = (e.target as HTMLInputElement).value; }}
            />
          </div>

          <button type="submit" class="auth-submit-ghost" tabindex="-1" aria-hidden="true">
            Send reset link
          </button>
          <luna-button full ?disabled=${this.busy} @click=${this.onSubmit}>
            <span>${this.busy ? 'Sending…' : 'Send reset link'}</span>
          </luna-button>
        </form>

        <div class="auth-links">
          <button class="auth-link" type="button" @click=${() => navigate('/login')}>
            Back to sign in
          </button>
        </div>
      </luna-auth-card>
    `;
  }
}
